module.exports = __webpack_public_path__ + "static/media/praxis-aussen.3af176b3.jpg";